/* @flow */
import * as React from 'react';
import idx from 'idx';

import AdminUpgradePageView from 'admin/components/AdminUpgradePageView.jsx';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator.jsx';

import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

type Props = {
  organizationUuid: ?string,
  data: ReactApolloData<AdminUpgradePageQuery>,
};

const AdminUpgradePage = function(props: Props) {
  const { organizationUuid, data } = props;
  const loading = idx(data, _ => _.loading);
  const quote = idx(data, _ => _.organizations[0].quoteRequestedByUser);

  return loading ? (
    <CenteredLoadingIndicator data-test="loading" />
  ) : (
    <AdminUpgradePageView organizationUuid={organizationUuid} quote={quote} />
  );
};

const withData = graphql(
  gql`
    query AdminUpgradePage($organizationUuid: String!) {
      organizations(uuids: [$organizationUuid]) {
        uuid
        quoteRequestedByUser {
          uuid
          studentsCount
          teachersCount
          startDate
          endDate
          taxExempt
          purchaseOrderNumber
          price
          shareToken
          tax
          total
          organization {
            uuid
            type
          }
          organizationAddress {
            latitude
            longitude
            streetAddress
            city
            state
            country
            postalCode
          }
        }
      }
    }
  `,
  {
    skip: ({ organizationUuid }) => !organizationUuid,
    options: ({ organizationUuid }) => ({
      variables: {
        organizationUuid,
      },
      fetchPolicy: 'network-only',
    }),
  }
);

export { AdminUpgradePage };
export default compose(withData)(AdminUpgradePage);
